import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService, Notification } from '../../../services/notification.service';

@Component({
  selector: 'app-notification',
  template: `
    <div class="notification-container">
      <div 
        *ngFor="let notification of notifications; trackBy: trackByFn"
        class="notification"
        [ngClass]="'notification-' + notification.type"
        (click)="removeNotification(notification.id)">
        
        <div class="notification-content">
          <div class="notification-icon">
            <i [ngClass]="getIconClass(notification.type)"></i>
          </div>
          <div class="notification-message">
            {{ notification.message }}
          </div>
          <div class="notification-close" (click)="removeNotification(notification.id)">
            <i class="las la-times"></i>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {
  notifications: Notification[] = [];
  private subscription: Subscription = new Subscription();

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {
    this.subscription = this.notificationService.getNotifications().subscribe(
      notifications => {
        this.notifications = notifications;
      }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  removeNotification(id: number) {
    this.notificationService.removeNotification(id);
  }

  trackByFn(index: number, item: Notification) {
    return item.id;
  }

  getIconClass(type: string): string {
    switch (type) {
      case 'success':
        return 'las la-check-circle';
      case 'error':
        return 'las la-exclamation-circle';
      case 'warning':
        return 'las la-exclamation-triangle';
      case 'info':
      default:
        return 'las la-info-circle';
    }
  }
}